import { LABEL_PRINTER_STORAGE_KEY } from '../config_and_helpers/labelPrinterConfig';

/**
 * @returns {string|null}
 */
export const getSavedPrinterName = () => {
  try {
    const value = localStorage.getItem(LABEL_PRINTER_STORAGE_KEY);
    return value && value.trim() ? value.trim() : null;
  } catch {
    return null;
  }
};

/**
 * @param {string} name
 */
export const setSavedPrinterName = name => {
  try {
    if (name && name.trim()) {
      localStorage.setItem(LABEL_PRINTER_STORAGE_KEY, name.trim());
    } else {
      localStorage.removeItem(LABEL_PRINTER_STORAGE_KEY);
    }
  } catch {
    // ignore quota / private mode
  }
};
